export interface Operation {
  name: string;
  visibleName: string;
  description: string | null;
}

/*
  CONSIDER THESE AS KEYS OF EACH OPERATION
   */
export enum OperationEnum {
  CREATE = 'create',
  MODIFY = 'modify',
  REMOVE = 'remove',
  READ = 'read',
}

export const Operations = {
  create: OperationEnum.CREATE,
  modify: OperationEnum.MODIFY,
  remove: OperationEnum.READ,
  read: OperationEnum.REMOVE,
};

export const OperationNumbers = {
  [OperationEnum.CREATE]: 'create',
  [OperationEnum.MODIFY]: 'modify',
  [OperationEnum.READ]: 'remove',
  [OperationEnum.REMOVE]: 'read',
};

export const OperationString = {
  [OperationEnum.CREATE]: 'Crea',
  [OperationEnum.MODIFY]: 'Modifica',
  [OperationEnum.READ]: 'Leggi',
  [OperationEnum.REMOVE]: 'Rimuovi',
};

export const OperationShortString = {
  [OperationEnum.CREATE]: 'C',
  [OperationEnum.MODIFY]: 'M',
  [OperationEnum.READ]: 'L',
  [OperationEnum.REMOVE]: 'R',
};
